module.exports = __webpack_public_path__ + "static/img/about_zhuzq01.430c196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_zhuzq01.png
// module id = aS1B
// module chunks = 1